export enum AppPermission {
  CanViewUsers = 'Can View Users',
  CanRunDevTesting = 'Can Run Dev Testing',
  CanViewDevTesting = 'Can View Dev Testing',
  CanRunUATTesting = 'Can Run UAT Testing',
  CanViewUATTesting = 'Can View UAT Testing',
  CanRegisterModel = 'Can Register Model',
  CanVersioningModel = 'Can Versioning a Model',
  CanViewDashboardStats = 'Can View Dashboard Stats',
  CanPerformModelMonitoring = 'Can Perform Model Monitoring',
  CanViewModelMonitoring = 'Can View Model Monitoring',
  CanAccessModelMonitoring = 'Can Access Model Monitoring',
  CanViewPerformanceMonitoring = 'Can View Performance Monitoring',
  CanViewPermissions = 'Can View Permissions',
  CanEditPermissions = 'Can Edit Permissions',
  CanViewDeployments = 'Can View Deployments',
  CanPromoteToProduction = 'Can Promote To Production',
  CanViewPromotionHistory = 'Can View Promotion History',
  CanViewModels = 'Can View Models',
  CanAccessFilesService = 'Can Access Files Service',
  CanEnableModelMarketing = 'Can Enable Model Marketing',
  CanDoProductionRun = 'Can Do Production Run',
  CanViewProductionRun = 'Can View Production Run',
  CanDownloadSwagger = 'Can Download Swagger',
  CanArchiveModelVersion = 'Can Archive Model Version',
  CanRestoreModel = 'Can Restore Model',
  CanViewModelStaticScanReport = 'Can View Model Static Scan Report',
}
